/**
 * OLS public forms client for carnival-night-quiz (GET schema → POST submit).
 *
 * ESM exports on purpose: async + Babel helpers break `module.exports` under Mix 4
 * ("Cannot assign to read only property 'exports'").
 */

function trimBase(olsBase) {
  return String(olsBase || '').replace(/\/$/, '');
}

export async function fetchQuizSchema(olsBase, lang) {
  const url =
    trimBase(olsBase) +
    '/ols/public/forms/carnival-night-quiz?lang=' +
    encodeURIComponent(lang);
  const res = await fetch(url, { headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error('schema_' + res.status);
  return res.json();
}

export async function submitQuizLead(olsBase, payload) {
  const lang = payload.lang;
  const answers = payload.answers;
  const utm = payload.utm || {};
  // The OLS host is internal. The browser posts to this site, which forwards the lead.
  const url = '/api/ticket-quiz/lead';
  const body = Object.assign({ answers: answers, lang: lang }, utm);
  void olsBase;
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });
  let parsed = {};
  try {
    parsed = await res.json();
  } catch (e) {
    parsed = {};
  }
  return { status: res.status, body: parsed };
}
